
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.001","d":"M44.32 24.397 25.744 8.664l-12.256 3.384-6.652 13.119 13.967 20.172 7.877-6.029"}}),_c('path',{attrs:{"stroke":"#234652","stroke-width":"1.001","d":"M6.745 6.338c.78-.92 2.162-1.289 3.893-1.005 1.719.281 3.687 1.2 5.474 2.714C17.9 9.56 19.13 11.35 19.69 12.999c.564 1.66.428 3.086-.35 4.005-.78.92-2.164 1.29-3.894 1.006-1.72-.281-3.687-1.2-5.474-2.713s-3.018-3.304-3.579-4.953c-.564-1.66-.427-3.086.352-4.006Z"}}),_c('path',{attrs:{"stroke":"#fff","stroke-width":"1.001","d":"M16.996 18.084c-1.19.102-2.62-.197-4.099-.891"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"square","stroke-linejoin":"round","stroke-width":"1.001","d":"M30.744 40.427 12.168 24.695l1.32-12.646 12.256-3.384L44.32 24.397z"}}),_c('circle',{attrs:{"cx":"19.276","cy":"16.951","r":"2.417","stroke":"#234652","stroke-width":"1.001","transform":"rotate(-49.739 19.276 16.95)"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"m18.811 26.72 9.973-11.777 11.776 9.973-9.973 11.776z"}})])
          )
        }
      }
    